// core/interceptors/jwt.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthenticationService } from '@core/services/authentication.service';
import { environment } from 'environments/environment';

export const JwtInterceptor: HttpInterceptorFn = (request, next) => {
  const authenticationService = inject(AuthenticationService);
  const currentUser = authenticationService.currentUser;
  const isLoggedIn = currentUser && currentUser.token;
  const isApiUrl = request.url.startsWith(environment.PackagingUrl);

  if (isLoggedIn && isApiUrl) {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${currentUser.token}`
      }
    });
  }

  return next(request);
};
